import { Link } from 'react-router-dom'
import { useState } from 'react'
import { useNewsletterSignup } from '../lib/newsletter'

export default function NewsletterBlock() {
  const [email, setEmail] = useState('')
  const { done, sending, error, onSubmit } = useNewsletterSignup()

  return (
    <section data-reveal id="newsletter" className="my-[clamp(28px,4.5vw,60px)] bg-ink px-[clamp(22px,4vw,60px)] py-[clamp(32px,5vw,80px)] text-white">
      <div className="grid min-w-0 grid-cols-1 items-end gap-[clamp(24px,3vw,56px)] lg:grid-cols-2">
        <h2 className="text-caps-display m-0 text-white">TIGG your inbox.</h2>
        <div className="flex flex-col gap-[18px]">
          <p className="m-0 max-w-[38ch] leading-relaxed text-white">
            the tea, the trends, and the one thing worth buying this week. sent friday, read in three minutes.
          </p>
          {done ? (
            <p className="font-serif text-2xl text-rose-soft">you’re in. friday is going to be fun.</p>
          ) : (
            <form onSubmit={(event) => void onSubmit(event)} className="flex min-w-0 flex-col sm:flex-row">
              <label className="sr-only" aria-hidden="true">
                Website
                <input name="website" tabIndex={-1} autoComplete="off" />
              </label>
              <input
                type="email"
                name="email"
                required
                autoComplete="email"
                aria-label="Email address"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="your@email.com"
                className="h-12 w-full min-w-0 flex-1 border-0 bg-white px-4 font-sans text-sm text-ink outline-none sm:w-auto"
              />
              <button
                type="submit"
                disabled={sending}
                className="text-caps h-12 w-full shrink-0 bg-rose-soft px-6 text-ink hover:bg-rose-wash disabled:opacity-60 sm:w-auto"
              >
                {sending ? 'Subscribing…' : 'Subscribe'}
              </button>
            </form>
          )}
          {error ? (
            <p role="alert" className="m-0 text-sm text-rose-soft">
              {error}
            </p>
          ) : null}
          <span className="max-w-[46ch] text-[11px] leading-normal text-[#d8d4cd]">
            By subscribing you agree to receive emails from TIGG and accept our{' '}
            <Link to="/terms/" className="underline underline-offset-2">
              terms of use
            </Link>{' '}
            and{' '}
            <Link to="/privacy/" className="underline underline-offset-2">
              privacy policy
            </Link>
            .
          </span>
        </div>
      </div>
    </section>
  )
}
